// extracted by mini-css-extract-plugin
export default {"slideBtn":"SlideIcon_slideBtn__XwMzx","modal":"SlideIcon_modal__U4KM9"};